import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';

@Injectable({ providedIn: 'root' })
export class MedalliaService {
  private readonly httpClient = inject(HttpClient);

  getMedalliaInfo(): Observable<string> {
    const url = 'api/v1/medallia-integration/info';

    return this.httpClient.get(environment.portalApiUrl + url, { responseType: 'text' });
  }
}
